export const pokeMartData = {
    test_town_mart: {
        preInteractionText: 'Welcome to the Poke Mart! How can I help you?',
        postInteractionText: 'See you next time!',
        inventory: [
            {
                itemId: 'potion',
                cost: 200,
            },
            {
                itemId: 'super_potion',
                cost: 400,
            },
            {
                itemId: 'paralyze_heal',
                cost: 350,
            },
            {
                itemId: 'antidote',
                cost: 350,
            },
            {
                itemId: 'pokeball',
                cost: 200,
            },
            {
                itemId: 'great_ball',
                cost: 500,
            },
            {
                itemId: 'ultra_ball',
                cost: 1000,
            },
            {
                itemId: 'master_ball',
                cost: 999999,
            },
            {
                itemId: 'rare_candy',
                cost: 10,
            },
        ],
    },
};
